<p class="vc-admin-form__section-subtitle">
  {{ 'ADMIN.ROLES.DETAIL.AVAILABLE_PERMISSIONS_HINT' | translate }}
</p>
@if (isLockedAdminRole) {
<p class="vc-admin-form__section-subtitle">
  {{ 'ADMIN.ROLES.DETAIL.ADMIN_ROLE_LOCKED_HINT' | translate }}
</p>
}

<div class="vc-role-permissions">
  @for (group of groupedResources; track group.code) {
  <section class="vc-role-permissions__group">
    <header class="vc-role-permissions__group-header">
      <h4>{{ getDomainTitle(group.code) }}</h4>
      <p>{{ getDomainDescription(group.code) }}</p>
    </header>

    @if (isAdministrationGroup(group)) {
    <div class="vc-role-permissions__subgroups">
      @for (subgroup of getAdministrationSubgroups(group); track subgroup.code) {
      <section class="vc-role-permissions__subgroup">
        @if (subgroup.code !== 'ACCESS') {
        <header class="vc-role-permissions__subgroup-header">
          <h5>{{ getAdministrationSubgroupTitle(subgroup.code) }}</h5>
          <p>{{ getAdministrationSubgroupDescription(subgroup.code) }}</p>
        </header>
        }

        <div class="vc-role-permissions__rows">
          @for (resource of subgroup.resources; track resource.id) {
          <article class="vc-role-permissions__row" [class.vc-role-permissions__row--disabled]="
              isResourceSwitchDisabled(resource)
            ">
            <div class="vc-role-permissions__row-copy">
              <p class="vc-role-permissions__row-title">
                {{ resource.name | resourceLabel : "TITLE" }}
              </p>
              <p class="vc-role-permissions__row-description">
                {{ resource.name | resourceLabel : "DESCRIPTION" }}
              </p>
            </div>

            <div class="vc-role-permissions__row-action">
              @if (isLockedAdminRole) {
              <span class="vc-role-permissions__active-chip">{{ "COMMON.ACTIVE" | translate }}</span>
              } @else {
              <p-inputSwitch (onChange)="this.updatePermission($event, resource, 'value')"
                [(ngModel)]="permissionsStatus[resource.id]['value']"
                [disabled]="isResourceSwitchDisabled(resource)"></p-inputSwitch>
              }
            </div>
          </article>
          }
        </div>
      </section>
      }
    </div>
    } @else {
    <div class="vc-role-permissions__rows">
      @for (resource of group.resources; track resource.id) {
      <article class="vc-role-permissions__row" [class.vc-role-permissions__row--disabled]="
          isResourceSwitchDisabled(resource)
        ">
        <div class="vc-role-permissions__row-copy">
          <p class="vc-role-permissions__row-title">
            {{ resource.name | resourceLabel : "TITLE" }}
          </p>
          <p class="vc-role-permissions__row-description">
            {{ resource.name | resourceLabel : "DESCRIPTION" }}
          </p>
        </div>

        <div class="vc-role-permissions__row-action">
          @if (isLockedAdminRole) {
          <span class="vc-role-permissions__active-chip">{{ "COMMON.ACTIVE" | translate }}</span>
          } @else {
          <p-inputSwitch (onChange)="this.updatePermission($event, resource, 'value')"
            [(ngModel)]="permissionsStatus[resource.id]['value']"
            [disabled]="isResourceSwitchDisabled(resource)"></p-inputSwitch>
          }
        </div>
      </article>
      }
    </div>
    }
  </section>
  }
</div>